import { useState, useEffect, useCallback } from 'react';
import ParentHeader from '@/components/common/ParentHeader';
import AddChildModal from '@/components/modals/AddChildModal';
import { getChildren, updateChild } from '@/services/parent';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { Pencil, User, CheckCircle, Clock, Plus } from 'lucide-react';
import toast from 'react-hot-toast';
import { fontSize, fontWeight, textColor } from '@/theme';
import { useScreenPermission } from '@/hooks/useScreenPermission';
import PaymentModal from '../modals/PaymentModal';
import PaymentProcessingLoader from '../modals/PaymentProgressingModal';
import useBuyNow from '@/hooks/useBuyNow';
import { fetchMatchingDiscountChildren } from '@/lib/utils/discount';

export default function PlansComponent() {
  const userDetails = useCurrentUser();
  const username = userDetails?.username || '';

  const [children, setChildren] = useState<any[]>([]);
  const [loadingChildren, setLoadingChildren] = useState(true);
  const [showAddChild, setShowAddChild] = useState(false);
  const [editingChild, setEditingChild] = useState<any>(null);
  const { canCreate: canCreateChild ,canUpdate :canUpdateChild } = useScreenPermission("child");
  const [renewalChild, setRenewalChild] = useState<boolean>(false);
  const {
    rewardBalance,
    offers,
    selectedOfferAmount,
    setSelectedOfferAmount,
    usedRewardAmount,
    setUsedRewardAmount,
    paymentCalculation,
    showSavingsModal,
    isProcessingPayment,
    openBuyNow,
    specialOffers,
    openBuyNowModal,
    paymentData,
    closeBuyNow,
    handleBuyNow,
    selectedSpecialOfferAmount,
  setSelectedSpecialOfferAmount,
  } = useBuyNow({
    username,
    onSuccess: () => loadChildren(),
    onRefresh:  () => loadChildren()
  });

  const loadChildren = useCallback(async () => {
    if (!username) return;
    setLoadingChildren(true);
    try {
      const response = await getChildren(username);
      if (response.status === 200 && response.data) {
        const data = response.data as any;
        const userData = Array.isArray(data) ? data[0] : data;
        const childList = userData?.childs || userData?.Childs || [];
        setChildren(Array.isArray(childList) ? childList : []);
      }
    } catch (error) {
      console.error('Failed to load children:', error);
    } finally {
      setLoadingChildren(false);
    }
  }, [username]);

  useEffect(() => {
    loadChildren();
  }, [loadChildren]);


  const handlePayChild = async (child: any) => {
  try {
    // =====================================================
    // 1. GET LATEST CHILD DETAILS
    // =====================================================

    const response = await getChildren(username);

    let latestChild = child;

    if (response.status === 200 && response.data) {
      const data = response.data as any;

      const userData = Array.isArray(data)
        ? data[0]
        : data;

      const childList =
        userData?.childs ||
        userData?.Childs ||
        [];

      if (Array.isArray(childList)) {
        latestChild =
          childList.find(
            (c: any) =>
              String(c.id) === String(child.id)
          ) || child;

        setChildren(childList);
      }
    }

    // console.log("LATEST CHILD:", latestChild);

    // =====================================================
    // 2. GET PLAN + PERIOD
    // =====================================================

    const planName =
      latestChild?.Plan_Name || "";

    const range =
      latestChild?.Range?.Period ||
      latestChild?.Range ||
      "";

const price =latestChild?.Range?.Base_Price 
    

    if (!planName || !range) {
      toast.error("Plan or range is missing");
      return;
    }

    // =====================================================
    // 3. GET CURRENT SAVED DISCOUNT FROM CHILD DETAILS
    // =====================================================

    const existingDiscount = Number(
      latestChild?.child_discount || 0
    );

    const existingDiscountAmount = Number(
      latestChild?.child_discount_amount || 0
    );

    const savedFinalAmount = Number(
      latestChild?.Range?.Final_Amount ??
      latestChild?.Final_Amount ??
      latestChild?.Amount ??
      0
    );

    // console.log("CHILD DISCOUNT FROM CHILD API:", {
    //   existingDiscount,
    //   existingDiscountAmount,
    //   savedFinalAmount,
    // });

    // =====================================================
    // 4. GET ORIGINAL AMOUNT
    //
    // If child already had 50% discount:
    //
    // Final_Amount = original - discount
    //
    // So:
    // original = Final_Amount + discount_amount
    //
    // If there was no discount:
    // original = Final_Amount
    // =====================================================

    let fullAmount = savedFinalAmount;

    if (
      existingDiscount > 0 &&
      existingDiscountAmount > 0
    ) {
      fullAmount = Number(
        (
          savedFinalAmount +
          existingDiscountAmount
        ).toFixed(2)
      );
    }

    if (
      !Number.isFinite(fullAmount) ||
      fullAmount <= 0
    ) {
      toast.error(
        "Unable to calculate subscription amount"
      );
      return;
    }

    // console.log("ORIGINAL AMOUNT:", fullAmount);

    // =====================================================
    // 5. CALL DISCOUNT API
    // =====================================================

    const matchingChildren =
      await fetchMatchingDiscountChildren({
        username,
        planName,
        range,
        type: "Subscribed",
        currentChild: latestChild,price
      });

    // console.log(
    //   "MATCHING DISCOUNT CHILDREN:",
    //   matchingChildren
    // );

    const hasMatchingChild =
      matchingChildren.length > 0;

    // =====================================================
    // 6. CALCULATE DISCOUNT
    //
    // MATCHING CHILD:
    //     50% discount
    //
    // NO MATCHING CHILD:
    //     0% discount = 100% payable
    // =====================================================

    const childDiscount =
      hasMatchingChild ? 50 : 0;

    const childDiscountAmount =
      hasMatchingChild
        ? Number(
            (fullAmount * 0.5).toFixed(2)
          )
        : 0;

    const childPayableAmount =
      Number(
        (
          fullAmount -
          childDiscountAmount
        ).toFixed(2)
      );

    console.log(
      "FINAL DISCOUNT CALCULATION:",
      {
        fullAmount,
        hasMatchingChild,
        childDiscount,
        childDiscountAmount,
        childPayableAmount,
      }
    );

    // =====================================================
    // 7. OPEN PAYMENT MODAL
    // =====================================================
console.log(latestChild,'latesthild')
    openBuyNow({
  subscriptionCode:
    latestChild?.Subscription_Code || "",

  childIds: [
    latestChild.id,
  ],

  totalAmount:
    childPayableAmount,
Range:latestChild.Range,
  items: [
    {
      planName:
        latestChild?.Plan_Name || "",

      amount:
        childPayableAmount,

      duration:
        latestChild?.Range?.Period || "",

      range:
        latestChild?.Lal_Lon_Km ??
        latestChild?.DistanceKm ??
        0,
    },
  ],

  child: {
    ...latestChild,

    child_original_amount:
      fullAmount,

    child_discount:
      childDiscount,

    child_discount_amount:
      childDiscountAmount,

    Range: {
      ...latestChild?.Range,

      Final_Amount:
        childPayableAmount,
    },
  },
});

  } catch (error: any) {
    console.error(
      "PAY CHILD ERROR:",
      error
    );

    toast.error(
      error?.response?.data?.message ||
      "Unable to prepare payment"
    );
  }
};

  const getFinalAmount = (child: any) => {
    const amount =
      child?.Range?.Final_Amount ??
      child?.Final_Amount ??
      child?.payment_amount;

    const parsed = parseFloat(String(amount));

    return Number.isFinite(parsed) ? parsed : null;
  };

  const handleEditChild = async (child: any) => {
    if (child.Verification_Status) {
      toast.error('Cannot edit a verified child');
      return;
    }
    await loadChildren();

    const latest =
      children.find(
        c =>
          c.id === child.id
      );

    setEditingChild(
      latest || child
    );

    setShowAddChild(
      true
    );
  };

  const handleStartTrial = async (childIds: number[]) => {
    try {
      const payload = {
        Trail:true
      }
      for (const childId of childIds) {
        await updateChild(childId, payload)
      }
  
      toast.success("Free Trial Activated");
      closeBuyNow();
    } catch (error) {
      toast.error("Unable to activate free trial");
    }
  };

  const handleCloseModal = async() => {
    setShowAddChild(false);
    setEditingChild(null);
    setRenewalChild(false)
    loadChildren();
  };

  const handleChildSuccess = async () => {
    setShowAddChild(false);
    setEditingChild(null);
    setRenewalChild(false);

     loadChildren();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <ParentHeader />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">

        <div className="mb-8">
          <h1 className={`${fontSize['3xl']} ${fontWeight.bold} ${textColor.heading}`}>
            Children
          </h1>
          <p className={`${textColor.muted} mt-1 text-sm`}>
            Manage your registered children
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className={`${fontSize['2xl']} ${fontWeight.bold} ${textColor.heading}`}>
                Your Children
              </h2>
              {!loadingChildren && (
                <p className={`text-sm ${textColor.muted} mt-0.5`}>
                  {children.length} {children.length === 1 ? 'child' : 'children'} registered
                </p>
              )}
            </div>
            {canCreateChild && (
              <button
                onClick={() => { setEditingChild(null); setShowAddChild(true); }}
                className="flex items-center gap-2 px-5 py-2.5 bg-brand-500 text-white rounded-xl hover:bg-brand-700 transition-colors shadow-sm text-sm font-semibold"
              >
                <Plus className="w-4 h-4" />
                Add Child
              </button>
            )}

          </div>

          {loadingChildren ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {[1, 2, 3].map(i => (
                <div key={i} className="border border-gray-100 rounded-xl p-6 animate-pulse">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gray-200 rounded-xl flex-shrink-0" />
                    <div className="flex-1 space-y-2">
                      <div className="h-4 bg-gray-200 rounded w-3/4" />
                      <div className="h-3 bg-gray-100 rounded w-1/2" />
                      <div className="h-3 bg-gray-100 rounded w-2/3" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : children.length === 0 ? (
            <div className="text-center py-14 border-2 border-dashed border-gray-200 rounded-xl">
              <div className="w-16 h-16 bg-brand-50 rounded-full flex items-center justify-center mx-auto mb-4">
                <User className="w-8 h-8 text-brand-400" />
              </div>
              <h3 className={`${fontWeight.bold} ${textColor.heading} mb-1`}>No children registered</h3>
              <p className={`text-sm ${textColor.muted} mb-5`}>
                Add your child to get started with a subscription plan
              </p>
              <button
                onClick={() => setShowAddChild(true)}
                className="flex items-center gap-2 px-5 py-2.5 bg-brand-500 text-white rounded-xl hover:bg-brand-700 transition-colors font-semibold text-sm mx-auto"
              >
                <Plus className="w-4 h-4" />
                Add First Child
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {children.map((child: any) => {
                const isVerified = !!child.Verification_Status;
                return (
                  <div
                    key={child.id || child.Child_Id}
                    className={`border-2 rounded-xl p-5 transition-colors ${isVerified
                      ? 'border-green-200 bg-green-50/40'
                      : 'border-gray-200 bg-white hover:border-brand-200'
                      }`}
                  >
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex items-center gap-3">
                        <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${isVerified ? 'bg-green-100' : 'bg-brand-100'
                          }`}>
                          <span className={`${fontSize.lg} ${fontWeight.bold} ${isVerified ? 'text-green-600' : 'text-brand-500'}`}>
                            {child.Child_Name?.[0]?.toUpperCase()}
                          </span>
                        </div>
                        <div>
                          <h3 className={`${fontWeight.bold} ${textColor.heading} text-sm leading-tight`}>
                            {child.Child_Name}
                          </h3>
                          <p className={`text-xs ${textColor.muted} mt-0.5`}>
                            {child.Child_Id}
                          </p>
                        </div>
                      </div>
                      <div className='flex flex-row flex-end items-center'>
                          {child.Record === "Renewal" && !child.Status && (
                              <span className="px-2 py-1 text-xs text-center rounded-full bg-orange-100 text-orange-600 font-semibold">
                                Renewal Pending
                              </span>
                            )}
                            {child.Record !== "Renewal" && child.Verification_Status && (
                              child.Status ? (
                                <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-600 font-semibold">
                                  Active
                                </span>
                              ) : (
                                <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-600 font-semibold">
                                  Expired
                                </span>
                              )
                            )}
                        {child.Record === "Renewal" ? (
                        child.payment_status !== "Paid" ? (
                          <button
                            onClick={() => handlePayChild(child)}
                            className="flex items-center gap-1 px-3 py-1.5 mx-2 bg-green-500 text-white text-sm rounded-lg hover:bg-green-700 transition-colors"
                          >
                            Pay
                          </button>
                        ) : (
                          <span className="flex items-center gap-1 px-3 py-1.5 mx-2 bg-green-500 text-white text-sm rounded-lg">
                            Paid
                          </span>
                        )
                      ) : child.Verification_Status ? (child.Status ? child.payment_status !== "Paid" ? (
                          <button
                            onClick={() => handlePayChild(child)}
                            className="flex items-center gap-1 px-3 py-1.5 mx-2 bg-green-500 text-white text-sm rounded-lg hover:bg-green-700 transition-colors"
                          >
                            Pay
                          </button>
                        ) : (
                          <span
                            className="flex items-center gap-1 px-3 py-1.5 mx-2 bg-green-500 text-white text-sm rounded-lg hover:bg-green-700 transition-colors"
                          >
                            Paid
                          </span>
                        ) : (
                          <button
                            onClick={() => {
                              setRenewalChild(true)
                              handleEditChild(child)
                            }}
                            className="flex items-center gap-1 px-3 py-1.5 mx-2 bg-green-500 text-white text-sm rounded-lg hover:bg-green-700 transition-colors"
                          >
                            Renewal
                          </button>
                        )) : child.payment_status !== "Paid" ?
                          (<button
                            onClick={() => handlePayChild(child)}
                            className="flex items-center gap-1 px-3 py-1.5 mx-2 bg-green-500 text-white text-sm rounded-lg hover:bg-green-700 transition-colors"
                          >
                            Pay
                          </button>
                          ) : (
                            <span
                              className="flex items-center gap-1 px-3 py-1.5 mx-2 bg-green-500 text-white text-sm rounded-lg hover:bg-green-700 transition-colors"
                            >
                              Paid
                            </span>)}
                      </div>
                    </div>

                    <div className="space-y-1.5 mb-4">
                      <div className="flex items-center gap-2 text-xs text-gray-600">
                        <span className="font-medium text-gray-500 w-14 flex-shrink-0">Age</span>
                        <span>{child.Age} years</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-gray-600">
                        <span className="font-medium text-gray-500 w-14 flex-shrink-0">Class</span>
                        <span>
                          {child.Class}
                          {child.Section ? ` - ${child.Section}` : ''}
                          {child.Roll_No ? ` (Roll: ${child.Roll_No})` : ''}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-gray-600">
                        <span className="font-medium text-gray-500 w-14 flex-shrink-0">School</span>
                        <span className="truncate">{child.School || '—'}</span>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-gray-600">
                        <span className="font-medium text-gray-500 w-14 flex-shrink-0">Address</span>
                        <span>{child.Address || '—'}</span>
                      </div>
                      {/* {child.City && (
                        <div className="flex items-center gap-2 text-xs text-gray-600">
                          <span className="font-medium text-gray-500 w-14 flex-shrink-0">City</span>
                          <span>{child.City}</span>
                        </div>
                      )} */}
                    </div>

                    {child.Plan_Name && (
                      <div className="bg-brand-50 border border-brand-100 rounded-lg px-3 py-2 mb-4">
                        <p className="text-xs font-semibold text-brand-700 mb-0.5">{child.Plan_Name}</p>
                        <p className="text-xs text-brand-500">
                          {child.Range?.Period || ''}
                          {getFinalAmount(child) !== null &&
                            child.Range?.Final_Amount !== null
                            ? ` · ₹${getFinalAmount(child)?.toFixed(2)}`
                            : ''}
                        </p>
                      </div>
                    )}
                    {isVerified ? (
                      <span className="inline-flex w-fit items-center gap-1 text-xs font-semibold text-green-700 bg-green-100 border border-green-200 px-2 py-0.5 rounded-full">
                        <CheckCircle className="w-3 h-3" />
                        Verified
                      </span>
                    ) : (
                      <span className="inline-flex w-fit items-center gap-1 text-xs font-semibold text-orange-600 bg-orange-50 border border-orange-200 px-2 py-0.5 rounded-full mb-2">
                        <Clock className="w-3 h-3" />
                        Verification Pending
                      </span>
                    )}

                    {canUpdateChild && (
                      <button
                        onClick={() => handleEditChild(child)}
                        className="w-full flex items-center justify-center gap-1.5 py-2 border border-brand-300 text-brand-500 rounded-lg hover:bg-brand-50 transition-colors text-xs font-semibold"
                      >
                        <Pencil className="w-3.5 h-3.5" />
                        Edit Details
                      </button>
                    )}
                  </div>
                );
              })}

              <button
                onClick={() => { setEditingChild(null); setShowAddChild(true); }}
                className="border-2 border-dashed border-gray-300 rounded-xl p-5 flex flex-col items-center justify-center gap-3 hover:border-brand-400 hover:bg-brand-50/40 transition-colors group min-h-[200px]"
              >
                <div className="w-11 h-11 bg-gray-100 rounded-xl flex items-center justify-center group-hover:bg-brand-100 transition-colors">
                  <Plus className="w-5 h-5 text-gray-400 group-hover:text-brand-500 transition-colors" />
                </div>
                <span className="text-sm font-semibold text-gray-500 group-hover:text-brand-500 transition-colors">
                  Add Another Child
                </span>
              </button>
            </div>
          )}
        </div>
      </main>

      <AddChildModal
        isOpen={showAddChild}
        onClose={handleCloseModal}
        onSuccess={handleChildSuccess}
        editingChild={editingChild}
        renewalChild={renewalChild}
      />
      <PaymentModal
        open={openBuyNowModal}
        data={paymentData}
        onClose={closeBuyNow}
        onBuyNow={handleBuyNow}
        rewardBalance={rewardBalance}
        offers={offers}
        specialOffers={specialOffers}
        selectedOfferAmount={selectedOfferAmount}
        setSelectedOfferAmount={setSelectedOfferAmount}
        usedRewardAmount={usedRewardAmount}
        setUsedRewardAmount={setUsedRewardAmount}
        paymentCalculation={paymentCalculation}
        showSavingsModal={showSavingsModal}
        onStartTrial={handleStartTrial}
        setSelectedSpecialOfferAmount={setSelectedSpecialOfferAmount}
          selectedSpecialOfferAmount={selectedSpecialOfferAmount}
      />
      <PaymentProcessingLoader visible={isProcessingPayment} />
    </div>
  );
}
